import React, { useState, useEffect } from "react";

const ContactUs = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch("http://www.trinityhighschools.com/api/contacts.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);
  console.log(data);
  const paraStyle = {
    fontSize: "16px",
    fontWeight: "700",
  };
  return (
    <>
      {data &&
        data?.map((element, index) => {
          return (
            <>
              <div key={index}>
                <h3
                  style={{
                    color: "blue",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  ContactUs ({element.title})
                </h3>
                <div style={{ textAlign: "center", paddingTop: "10px" }}>
                  <p style={paraStyle}>{element.address1}</p>
                  <p style={paraStyle}>{element.address2}</p>
                  <p style={paraStyle}>{element.address3}</p>
                  <p style={paraStyle}>
                    <span>Contact No.{element.contact_no}</span>,{" "}
                    <span>Email Id: {element.email}</span>
                  </p>
                </div>
              </div>
              <hr style={{height:"2px",backgroundColor:"lightgray",width:"80%",margin:"auto"}}></hr>
            </>
          );
        })}
    </>
  );
};

export default ContactUs;
